import { Component, EventEmitter, Output } from '@angular/core';

export enum PaymentTypes {
  SPLIT_PAYMENT = 'SPLIT_PAYMENT',
  ONE_PAYMENT = 'ONE_PAYMENT',
}

@Component({
  selector: 'ew-split-payment',
  templateUrl: './split-payment.component.html',
})
export class SplitPaymentComponent {
  labels = {
    [PaymentTypes.SPLIT_PAYMENT]: 'paymentSplit:selectLabelSplit',
    [PaymentTypes.ONE_PAYMENT]: 'paymentSplit:selectLabelOnePayment',
  };

  options = [
    {
      value: PaymentTypes.ONE_PAYMENT,
      label: 'paymentSplit:selectLabelOnePayment',
    },
    {
      value: PaymentTypes.SPLIT_PAYMENT,
      label: 'paymentSplit:selectLabelSplit',
    },
  ];

  @Output()
  toggleSplitPaymentEvent = new EventEmitter<PaymentTypes>();

  paymentType: PaymentTypes = PaymentTypes.ONE_PAYMENT;

  toggleSplitPayment(value: PaymentTypes) {
    this.paymentType = value;
    this.toggleSplitPaymentEvent.emit(value);
  }
}
